<i18n>
{
  "en": {
    "start_login": "Login to start playing game automatically",
    "continue_with_google": "Continue with Google",
    "continue_with_facebook": "Continue with Facebook",
    "need_support": "Need support? Contact us",
    "browser_warning": "We have noticed that you are currently using an in-app browser, rather than a standalone one. To prevent in-app browser causing login issue, please click lower-right button ",
    "browser_warning_FB": "and tap 'Open in Safari/Chrome'",
    "browser_warning_Line": "and tap 'Open in browser'",
    "open_in_browser": "<p><v-icon>mdi-export-variant</v-icon> Open in Safari</p>",
    "fb_warning_header": "Having trouble logging in with Facebook?",
    "fb_warning_content": "<p>We are currently experiencing issues with Facebook login, which may affect the functionality of logging in via Facebook. We kindly encourage you to transition to Google login for a smoother experience. Please provide the following details through the specified channels listed below:</p><p>1. The email address associated with your Facebook account.<br/>2. An email address for a Google account that has previously logged into XRobotmon.<br/></p>",
    "fb_login_disabled": "Facebook signup has been disabled and is only available for existing members. New members please use Google login.",
    "login_failed": "Unable to complete login. Please try again."
  },
  "zhHant": {
    "start_login": "立即登入開始自動玩",
    "continue_with_google": "用 Google 登入",
    "continue_with_facebook": "用 Facebook 登入",
    "need_support": "需要支援嗎？聯絡我們",
    "browser_warning": "我們注意到您目前正在使用APP內瀏覽器，而不是獨立的瀏覽器。為了防止App內瀏覽器造成登入問題，請點擊右下角的按鈕",
    "browser_warning_FB": "並點擊 '在 Safari/Chrome 中開啟'",
    "browser_warning_Line": "並點擊 '在瀏覽器中打開'",
    "fb_warning_header": "無法使用Facebook登錄嗎？",
    "fb_warning_content": "<p>Facebook登入目前遇到問題，可能會影響到Facebook的登錄功能。為了讓您有更順暢的使用體驗，我們建議您切換到Google登錄。請通過下面列出的方式提供以下兩個email：</p><p>1. 與您的Facebook帳戶相關聯的電子郵件地址。<br/>2. 之前已經登入過XRobotmon的Google帳戶的電子郵件地址。<br/></p>",
    "fb_login_disabled": "Facebook 註冊已經停用，僅供舊會員使用，新會員請使用 Google 登入。",
    "login_failed": "無法完成登入，請再試一次。"
  },
  "ja": {
    "start_login": "ログインして、自動プレイを始めましょう",
    "continue_with_google": "Googleでログイン",
    "continue_with_facebook": "Facebookでログイン",
    "need_support": "お困りですか？ お問い合わせはこちら",
    "browser_warning": "現在、アプリ内ブラウザでご利用中のようです。ログインの不具合を防ぐため、画面右下のボタンをタップしてください。",
    "browser_warning_FB": "続いて「Safari／Chromeで開く」を選択してください。",
    "browser_warning_Line": "続いて「ブラウザで開く」を選択してください。",
    "fb_warning_header": "Facebookログインでお困りですか？",
    "fb_warning_content": "<p>現在、Facebookログインに不具合が発生しており、Facebookでのログインに影響が出る可能性があります。より快適にご利用いただくため、Googleログインへの切り替えをおすすめいたします。お手数ですが、下記の情報をお知らせください。</p><p>1. お使いのFacebookアカウントに登録されているメールアドレス<br/>2. 以前XロボットモンにログインしたことのあるGoogleアカウントのメールアドレス<br/></p>",
    "fb_login_disabled": "Facebookでの新規登録は終了しております。すでにご登録済みの方のみご利用いただけます。これから登録される方はGoogleログインをご利用ください。",
    "login_failed": "ログインを完了できませんでした。もう一度お試しください。"
  },
  "ko": {
    "start_login": "자동으로 게임을 시작하려면 로그인하세요",
    "continue_with_google": "Google로 로그인",
    "continue_with_facebook": "페이스북으로 로그인",
    "need_support": "지원이 필요하신가요? 문의하기",
    "browser_warning": "현재 앱 내 브라우저를 사용하고 계신 것을 확인했습니다. 독립 실행형 브라우저가 아닙니다. 앱 내 브라우저가 로그인 문제를 일으키는 것을 방지하기 위해, 오른쪽 하단의 버튼을 클릭해 주세요",
    "browser_warning_FB": "그리고 'Safari/Chrome 에서 열기'를 탭하세요",
    "browser_warning_Line": "그리고 '브라우저에서 열기' 를 탭하세요",
    "fb_warning_header": "Facebook 로그인에 문제가 있으신가요?",
    "fb_warning_content": "<p>Facebook 로그인에 현재 문제가 발생하고 있으며, 이로 인해 Facebook 로그인 기능에 영향을 줄 수 있습니다. 더 원활한 사용 경험을 위해 Google 로그인으로 전환하는 것을 권장합니다. 아래에 나열된 방법으로 다음 두 개의 이메일을 제공해 주세요:</p><p>1. Facebook 계정과 연결된 이메일 주소.<br/>2. XRobotmon에 이전에 로그인한 적 있는 Google 계정의 이메일 주소.<br/></p>", 
    "fb_login_disabled": "Facebook 가입이 중단되었으며, 기존 회원만 이용 가능합니다. 신규 회원은 Google 로그인을 이용해 주세요.",
    "login_failed": "로그인을 완료할 수 없습니다. 다시 시도해 주세요."
  }
}
</i18n>

<template>
  <div>
    <v-alert :value="isFB || isLine" type="warning">
      <div>
        {{ $t('browser_warning') }}
        <v-icon style="color: white">{{ iconType }}</v-icon>
        {{ warningMessage }}
      </div>
    </v-alert>

    <v-container>
      <v-layout column align-center justify-center>
        <div class="login-container">
          <div class="upper">
            <div class="logos">
              <img v-bind:src="robotmonLogoUrl" alt="xrobotmon" width="82" height="82" />
              <DotsSVG />
              <v-avatar tile size="100">
                <img v-bind:style="{ 'border-radius': '23px' }" v-bind:src="gameLogoUrl" />
              </v-avatar>
            </div>
            <h1>{{ $t('start_login') }}</h1>
          </div>
          <div class="buttons">
            <v-alert :value="loginError" type="error">{{ $t('login_failed') }}</v-alert>
            <button class="button" :disabled="signingIn" @click="loginWithGoogle">
              <GoogleSVG /><span>{{ $t('continue_with_google') }}</span>
            </button>
            <button class="support" :disabled="signingIn" @click="loginWithFacebook" size="small">
              <span>{{ $t('continue_with_facebook') }}</span>
            </button>
            <p>{{ $t("fb_login_disabled") }}</p>
            <button class="support" @click="contactUs">{{ $t('need_support') }}</button>
          </div>
        </div>
      </v-layout>

      <!-- When Facebook cannot be logged into, uncomment the following and deploy the webpage, informing users to switch to a Google account first. -->
      <!-- <v-expansion-panel>
        <v-expansion-panel-content>
          <template v-slot:header>
            <v-card-title class="px-0 py-0">
              <span class="font-weight-bold warning--text" :style="{ color: '#85929E', fontSize: '20px' }">
                {{ $t('fb_warning_header') }}
              </span>
            </v-card-title>
          </template>

<v-card class="px-2">
  <v-card-title :style="{ fontSize: '20px', paddingTop: '0px', paddingBottom: '4px' }">
    <div>
      <div v-html="$t('fb_warning_content')"></div>
    </div>
  </v-card-title>
</v-card>
<ContactInfo class="px-2" />
</v-expansion-panel-content>
</v-expansion-panel> -->
    </v-container>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
// import ContactInfo from '../components/ContactInfo';
import GoogleSVG from '@/assets/google-icon.svg';
import DotsSVG from '@/assets/dots.svg';
import assetMisc from '@/assets/misc';
import { capturedPathname, capturedSearch } from '@/misc/landing-capture';
import { resolveBounceTarget } from '@/misc/login-bounce';
import { establishInteractiveSession } from '@/services/authSession';

function resolveV1I18nLanguage(lang) {
  const lower = lang.toLowerCase();
  if (lower === 'ja' || lower.startsWith('ja-')) return 'ja';
  if (lower === 'ko' || lower.startsWith('ko-')) return 'ko';
  if (lower === 'en' || lower.startsWith('en-')) return 'en';
  if (lower.startsWith('zh')) return 'zhHant';
  return null;
}

export default {
  name: 'login',
  // components: { ContactInfo },
  components: { GoogleSVG, DotsSVG },
  data: () => {
    return {
      robotmonLogoUrl: assetMisc.robotmonLogoUrl,
      gameLogoUrl: '',
      signingIn: false,
      loginError: false
    };
  },
  mounted() {
    let alreadyBounced = false;
    try {
      alreadyBounced = sessionStorage.getItem('ab_login_bounced') === '1';
    } catch (e) {
      alreadyBounced = false;
    }

    const target = resolveBounceTarget({
      referrer: document.referrer,
      search: capturedSearch,
      i18nLanguage: this.$i18n.locale,
      alreadyBounced: alreadyBounced,
      landedPathname: capturedPathname
    });
    if (target) {
      try {
        sessionStorage.setItem('ab_login_bounced', '1');
      } catch (e) {
        // still bounce; failing to persist the guard must not block it
      }
      window.location.replace(target);
      return;
    }

    const langParams = new URLSearchParams(
      capturedSearch.startsWith('?') ? capturedSearch.slice(1) : capturedSearch
    );
    const lang = langParams.get('lang');
    if (lang) {
      const appLang = resolveV1I18nLanguage(lang);
      if (appLang && appLang !== this.$i18n.locale) {
        this.$i18n.locale = appLang;
      }
    }

    // check query params to show game logo
    const urlParams = new URLSearchParams(window.location.search);
    switch (urlParams.get('game')) {
      case 'tsum':
        this.gameLogoUrl = assetMisc.tsumLogoUrl;
        break;
      case 'cookieKingdom':
        this.gameLogoUrl = assetMisc.cookieKingdomLogoUrl;
        break;
      case 'mlb9i':
        this.gameLogoUrl = assetMisc.mlb9iLogoUrl;
        break;
      default:
        this.gameLogoUrl = assetMisc.gamesGifUrl;
    }
  },
  computed: {
    isLine() {
      var userAgent = window.navigator.userAgent.toLowerCase();
      return /line/i.test(userAgent); // Line will include this in their webview
    },
    isFB() {
      var userAgent = window.navigator.userAgent.toLowerCase();
      return /FBAN|FBAV|Instagram/i.test(userAgent); // FB will include this in their webview: fbmd/iphone
    },
    iconType() {
      return this.isLine ? 'mdi-dots-vertical' : 'mdi-export-variant';
    },
    warningMessage() {
      return this.isLine ? this.$t('browser_warning_Line') : this.$t('browser_warning_FB');
    }
  },
  methods: {
    loginWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account'
      });
      this.signInWithPopup(provider);
    },
    loginWithFacebook() {
      if (!window.FB) {
        this.loginError = true;
        return;
      }
      this.signingIn = true;
      this.loginError = false;
      window.FB.login(async response => {
        if (!response.authResponse) {
          this.signingIn = false;
          return;
        }
        try {
          const credential = firebase.auth.FacebookAuthProvider.credential(response.authResponse.accessToken);
          const result = await firebase.auth().signInWithCredential(credential);
          await establishInteractiveSession(result.user);
          window.location.reload();
        } catch (error) {
          this.loginError = true;
          this.signingIn = false;
        }
      });
    },
    async signInWithPopup(provider) {
      this.signingIn = true;
      this.loginError = false;
      try {
        const result = await firebase.auth().signInWithPopup(provider);
        await establishInteractiveSession(result.user);
        window.location.reload();
      } catch (error) {
        this.loginError = true;
        this.signingIn = false;
      }
    },
    contactUs() {
      this.$router.push('/faq');
    }
  }
};
</script>

<style scoped>
.login-container {
  padding: 60px 0;
}

.upper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
}

.logos {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
}

h1 {
  font-size: 16px;
  font-weight: 300;
  margin-top: 20px;
}

.buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.button {
  border-radius: 8px;
  border: 1px solid #dfdfdf;
  background-color: white;
  color: #606060;
  font: bold;
  padding: 12px 24px;
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.button span {
  flex: 1;
  font-weight: 700;
  font-size: 16px;
}

.button:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

.support {
  text-decoration: underline;
  text-underline-offset: 2px;
  color: #606060;
}
</style>
